function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M79.24 0a24 24 0 1024.05 24A24.07 24.07 0 0079.24 0zM48.08 24a24 24 0 10-24 24 24.07 24.07 0 0024-24zM3 24a21 21 0 1121 21A21.07 21.07 0 013 24zm34.36 106.71H10.72V57.9A38 38 0 0024 60.28a37.75 37.75 0 0013.32-2.39v15.77l3-2V53.35l-2.11.94a35.34 35.34 0 01-28.43 0l-2.1-.93v80.34h32.68v-32.86c-1 .54-2 1.08-3 1.63z"
}), React.createElement("path", {
  d: "M79.25 57.28a35.1 35.1 0 01-14.4-3.06l-1.58-.71-.48 1.67c-.72 2.58-4.91 8.81-24.74 21.61-4.44 2.86-9.49 5.92-14.62 8.87a9.14 9.14 0 00-4.61 8 9.22 9.22 0 009.18 9.2 9.24 9.24 0 004.23-1c2.7-1.4 5.1-2.69 7.36-3.94C51 91.52 58.81 86 62.93 81.47v52.24h32.64V53.35l-2.11.94a34.86 34.86 0 01-14.21 2.99z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 103.29 133.71"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/preventing-harms.svg";
export { SvgComponent as ReactComponent };